import moment from "moment";

import { MyleActionDTO } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ILabActionDetailsTooltipControl {
    ControlId: string;

    ReferenceId: string;

    EventToDispatchToClosePopup: number;
    leftPosition: number;
    topPosition: number;

    Model: MyleActionDTO;
}

class LabActionDetailsTooltipControl extends BaseReactComponent<ILabActionDetailsTooltipControl> {
    public render(): JSX.Element {
        let completedBy = "";
        if (this.props.Model.CompletedByEmployeeId != null)
            completedBy = cacheStore.GetCliniciansPersonsByContactFacetId(this.props.Model.CompletedByEmployeeId).NameWithPrefix;

        let createdby = "";
        if (this.props.Model.CreatedByEmployeeId != null)
            createdby = cacheStore.GetCliniciansPersonsByContactFacetId(this.props.Model.CreatedByEmployeeId).NameWithPrefix;

        let completedDate = "";
        if (this.props.Model.CompletedOn != null)
            completedDate = moment(this.props.Model.CompletedOn).format("YYYY/MM/DD HH:mm");

        let creationDate = "";
        if (this.props.Model.DateCreated != null)
            creationDate = moment(this.props.Model.DateCreated).format("YYYY/MM/DD HH:mm");

        const IsCompleted = completedDate == "";

        return (

            <Popup
                Id={this.props.ControlId}
                draggable={false}
                cssClass="labactiondetails"
                title={cacheStore.GetString("ActionLabel")}
                closeTarget={this.props.EventToDispatchToClosePopup}
                topPosition={this.props.topPosition + 5}
                leftPosition={this.props.leftPosition + 150}
            >

                <div className="p-body">
                    <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-5">
                            <span>{cacheStore.GetString("OriginalValueDLabel")}</span>
                        </div>

                        <div className="col-lg-7 col-md-7 col-sm-7">
                            <span>{this.props.Model.OriginalValue}</span>
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-lg-5 col-md-5 col-sm-5">
                            <span>{cacheStore.GetString("CreatedByLabel")}</span>
                        </div>

                        <div className="col-lg-7 col-md-7 col-sm-7">
                            <span>{createdby}</span>
                        </div>

                    </div>
                    <div className="row">

                        <div className="col-lg-5 col-md-5 col-sm-5">
                            <span>{cacheStore.GetString("CreatedOnDLabel")}</span>
                        </div>

                        <div className="col-lg-7 col-md-7 col-sm-7">
                            <span>{creationDate}</span>
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-lg-5 col-md-5 col-sm-5">
                            <span>{cacheStore.GetString("CompletedByLabel")}</span>
                        </div>

                        <div className="col-lg-7 col-md-7 col-sm-7">
                            <span>{completedBy}</span>
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-lg-5 col-md-5 col-sm-5">
                            <span>{cacheStore.GetString("CompletedOnLabel")}</span>
                        </div>

                        <div className="col-lg-7 col-md-7 col-sm-7">
                            <span>{completedDate}</span>
                        </div>

                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 text-right">
                            {IsCompleted && (
                                <div>
                                    <button className="btn btn-primary push-right-10" disabled={false} onClick={() => this.DeleteActionClick()}>{cacheStore.GetString("DeleteLabel")}</button>
                                    <button className="btn btn-primary" disabled={false} onClick={() => this.CompleteActionClick()}>{cacheStore.GetString("CompleteAction")}</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private CompleteActionClick(): void {
        const operation = new LocalEvent(LocalOperations.LabsUI.ActionDetails_CompleteAction);
        operation.AddItem("SubReferenceId", this.props.Model.Id);
        LocalEventDispatcher.dispatch(operation);
    }

    private DeleteActionClick(): void {
        const operation = new LocalEvent(LocalOperations.LabsUI.ActionDetails_DeleteAction);
        operation.AddItem("SubReferenceId", this.props.Model.Id);
        LocalEventDispatcher.dispatch(operation);
    }

    public shouldComponentUpdate(nextProp: ILabActionDetailsTooltipControl): boolean {
        const id_mismatch = this.props.ReferenceId !== nextProp.ReferenceId;
        const subid_mismatch = this.props.Model !== nextProp.Model;

        const position = this.props.leftPosition !== nextProp.leftPosition || this.props.topPosition !== nextProp.topPosition;
        return id_mismatch || position || subid_mismatch;
    }

    public componentDidMount(): void {
        this.setOverlay("LabActionsDetailsNotesPopup");

        $("#" + this.props.ControlId).on("opened.fndtn.dropdown", function() { $(this).find("textarea").css({ height: "40px" }); });
        $("#" + this.props.ControlId).on("closed.fndtn.dropdown", function() {
            if (this.props.EventToDispatchOnDropdownClosed != null) {
                const operation = new LocalEvent(this.props.EventToDispatchOnDropdownClosed);
                LocalEventDispatcher.dispatch(operation);
            }
        });
    }
}

export { LabActionDetailsTooltipControl };
